import { LSError } from '../util/LSError.interface';

export class ReplaceAnswersError extends Error implements LSError {
  message: string;
  title: string;

  constructor() {
    super();
    this.title = 'Replace Answers Error';
    this.message = 'There was an error Replacing your answers, please contact support if the error persists';
  }
}
